module.exports = __webpack_public_path__ + "img/218.e9fc0169.jpg";